import axios from "@/axios";

export const namespaced = true;

const defaultData = {
    orderId: 0,
    countryId: null,
    partnerOrganizationId: null,
    implimentArrangementId: null,
    theaterId: null
}

export const state = {
    agreementInfo: Object.assign({}, defaultData),
    agreementInfoErrors: [],
    status: false
};

export const getters = {
    agreementInfo: state => {
        return state.agreementInfo
    },
    agreementInformationStatus: state => {
        return state.status
    },
    agreementInfoSelectedCountryId: state => {
        return state.agreementInfo.countryId;
    },
    agreementInfoErrors: state => {
        return state.agreementInfoErrors
    }
};

export const mutations = {
    SET_AGREEMENT_INFO_COUNTRY_CHANGED(state, model) {
        state.agreementInfo = Object.assign({}, state.agreementInfo, model)
    },
    SET_AGREEMENT_INFO(state, response) {
        state.agreementInfo.countryId = response.data.countryId === 0 ? null : response.data.countryId;
        state.agreementInfo.implimentArrangementId = response.data.implimentArrangementId;
        state.agreementInfo.partnerOrganizationId = response.data.partnerOrganizationId === 0 ? null : response.data.partnerOrganizationId;
        state.agreementInfo.theaterId = response.data.theaterId === 0 ? null : response.data.theaterId;
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    CLEAR_DATA(state) {
        state.agreementInfo = Object.assign({}, defaultData)
    },
    SET_ERRORS(state, data) {
        state.agreementInfoErrors = data;
    },
    CLEAR_ERRORS(state) {
        state.agreementInfoErrors = [];
    }
};

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getAgreementInformationStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false)
        } else {
            return await axios.get('/api/agreementinformation/status/' + id)
                .then(({ data }) => {
                    if(data && data.length === 0) {
                        commit("SET_STATUS", true);
                        commit("CLEAR_ERRORS");
                    } else {
                        commit("SET_STATUS", false);
                        commit("SET_ERRORS", data);
                    }
                })
        }
    },
    async loadAgreementInformation({ commit}, orderId) {
        try {
            commit("SET_AGREEMENT_INFO", await axios.get(`/api/agreementinformation/${orderId}`));
        } 
        catch (error) {
            console.log("ERROR LOADING AGREEMENT INFORMATION: ", error); //not handelled
        }
    },
    async agreementInformationCountryChanged({ commit}, model) {
        commit("SET_AGREEMENT_INFO_COUNTRY_CHANGED", model);
    },
    async saveAgreementInfoToServer({ commit, state}, orderId) {
        return new Promise((resolve, reject) => {
            state.agreementInfo.orderId = orderId
            if(state.agreementInfo.implimentArrangementId === 0){
                state.agreementInfo.implimentArrangementId =  null
            }

            axios.post("/api/agreementinformation", state.agreementInfo)
                .then(function (response) {
                    return resolve(response.data);
                })
                .catch(function (error) {
                    // handle error
                    return reject("There was an error saving the Agreement Information to the server...  " + error.response.data);
                })
        });
    }
};